import { apiRequest } from './apiClient';

/**
 * Banka listesini getirir (select için)
 */
export const fetchBanks = async () => {
  return apiRequest('/api/banks/select', {
    method: 'GET',
    skipCsrf: true,
  });
};

